import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import withPillNavigationDecorator from '../../shared/withPillNavigation.decorator';
import ReactTooltip from 'react-tooltip';

import Report from '../../shared/report/report.component';
import { BOOK_TYPES } from './constants';
import Spinner from '../../shared/spinner.component';
import TaxExpenseDraftBanner from '../viewTaxExpensePage/draftBanner.component';

class TaxExpenseTEDView extends PureComponent {
  static propTypes = {
    reportData: PropTypes.shape({
      name: PropTypes.string,
      orientation: PropTypes.string,
      rows: PropTypes.arrayOf(PropTypes.shape({
        rowType: PropTypes.string,
        description: PropTypes.string,
        columns: PropTypes.arrayOf(PropTypes.shape({
          value: PropTypes.oneOfType([
            PropTypes.string,
            PropTypes.number,
          ]),
        })),
      })),
      columnCount: PropTypes.number,
    }),
    taxExpenseLoading: PropTypes.bool,
    reportTitlePrefix: PropTypes.string,
    useHistorical: PropTypes.bool,
    shouldShowDraftBanner: PropTypes.bool,
    disableDrillLink: PropTypes.bool,
    showExpandCollapseAllButton: PropTypes.bool,
  };

  componentDidMount() {
    ReactTooltip.rebuild();
  }

  render() {
    const {
      reportData, taxExpenseLoading, reportTitlePrefix, useHistorical, shouldShowDraftBanner, disableDrillLink,
      showExpandCollapseAllButton,
    } = this.props;

    return (
      <div className="ag-grid-full-page-with-secondary-menu">
        {!taxExpenseLoading && shouldShowDraftBanner ? <TaxExpenseDraftBanner /> : null}
        {taxExpenseLoading && <Spinner/>}
        {!taxExpenseLoading && reportData
          && (
            <Report
              data={reportData}
              sectionHeaderPrefix={reportTitlePrefix}
              useCustomDecimalNumber
              closePopupsOnScroll
              useHistorical={useHistorical}
              disableDrillLink={disableDrillLink}
              showExpandCollapseAllButton={showExpandCollapseAllButton}
            />
          )
        }
      </div>
    );
  }
}

const getPillDefs = ({ useHistorical, selectedBookTypes }) => [
  ...!useHistorical ? [{ label: 'US Summary', type: BOOK_TYPES.US_SUMMARY }] : [],
  { label: 'US Federal', type: BOOK_TYPES.US_FED },
  { label: 'US State', type: BOOK_TYPES.US_STATE },
  { label: 'GAAP Non-US', type: BOOK_TYPES.TED_NON_US_GAAP },
  { label: 'STAT Non-US', type: BOOK_TYPES.TED_NON_US_STAT },
].filter(({ type }) => !Array.isArray(selectedBookTypes) || selectedBookTypes.includes(type));

export default withPillNavigationDecorator(
  getPillDefs,
  {
    propTypes: {
      bookType: PropTypes.string.isRequired,
      selectedBookTypes: PropTypes.arrayOf(PropTypes.string),
      selectBookType: PropTypes.func.isRequired,
    },
    getActivePill: props => props.bookType,
    onPillChangeEventPropKey: 'selectBookType',
  }
)(TaxExpenseTEDView);
